import { mediaRef } from '@/services/mediaAssets';
import planeViewImage from '@/assets/adventures/aws-reinvent-2024-zion-plane-view.jpg';
import geologyBriefingImage from '@/assets/adventures/aws-reinvent-2024-zion-geology-briefing.jpg';

const newZionImage = (name) => mediaRef(`adventures/aws-reinvent-2024-zion-${name}.jpg`);
const rockPassageImage = newZionImage('rock-passage');
const slotCanyonCrewImage = newZionImage('slot-canyon-crew');
const waltersWigglesImage = newZionImage('walters-wiggles');
const scoutLookoutViewImage = newZionImage('scout-lookout-view');
const scoutLookoutCrewImage = newZionImage('scout-lookout-crew');
const wellEarnedDescentImage = newZionImage('well-earned-descent');
const trailEndsRiverImage = newZionImage('trail-ends-river');
const trailEndsCrewImage = newZionImage('trail-ends-crew');
const trailEndsRestImage = newZionImage('trail-ends-rest');
const chasingSunsetImage = newZionImage('chasing-sunset');
const watchmanOverlookImage = newZionImage('watchman-overlook');
const watchmanSunsetImage = newZionImage('watchman-sunset');
const watchmanTrailheadFinishImage = newZionImage('watchman-trailhead-finish');
const walkBackToVanImage = newZionImage('walk-back-to-van');
const finalSelfieWithSamanthaImage = newZionImage('final-selfie-with-samantha');

const nightSkyImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2864.jpg');
const sunriseCliffsImage = mediaRef('adventures/aws-reinvent-2024-zion-img-2867.jpg');
const canyonCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241207-080654.jpg');
const cliffsideCrewImage = mediaRef('adventures/aws-reinvent-2024-zion-20241201-085327.jpg');

const photo = (id, src, alt, caption = alt) => ({
  id: `zion-${id}`,
  src,
  alt,
  caption,
  position: 'center center',
});

export const zionPlaneViewPhoto = photo(
  'plane-view',
  planeViewImage,
  'Aerial view of Zion National Park sandstone cliffs from a plane approaching Las Vegas',
  'Our first glimpse of Zion from the plane window on the flight into Las Vegas.',
);

export const zionNightSkyPhoto = photo(
  'night-sky',
  nightSkyImage,
  'Stars above Zion before the 2024 hike began',
  'Looking up at one of the clearest night skies we had seen in years behind the hotel in Springdale.',
);

export const zionSunriseCliffsPhoto = photo(
  'sunrise-cliffs',
  sunriseCliffsImage,
  'Zion cliffs catching the first light of morning',
  'Our first view of Zion in daylight from the hotel parking lot in Springdale.',
);

export const zionScoutsLookoutStartPhoto = photo(
  'scouts-lookout-start',
  cliffsideCrewImage,
  'The Reckon crew at the beginning of the hike to Scout Lookout beneath a towering Zion cliff',
  'The crew together at the beginning of the hike to Scout Lookout.',
);

export const zionGeologyBriefingPhoto = photo(
  'geology-briefing',
  geologyBriefingImage,
  'Samantha explaining Zion geology to the Reckon crew during the hike to Scout Lookout',
  'Samantha explaining the geology surrounding us on the hike to Scout Lookout.',
);

export const zionSwitchbackGroupPhoto = photo(
  'switchback-group',
  canyonCrewImage,
  'The Reckon crew gathered at the end of a switchback above Zion Canyon',
  'A group photo at the end of one of the switchbacks on the climb to Scout Lookout.',
);

export const zionRockPassagePhoto = photo(
  'rock-passage',
  rockPassageImage,
  'A narrow passage hidden among the Zion sandstone formations',
  'A new perspective hidden within a narrow passage just off the trail.',
);

export const zionSlotCanyonCrewPhoto = photo(
  'slot-canyon-crew',
  slotCanyonCrewImage,
  'The Reckon crew smiling together inside a narrow Zion sandstone passage',
  'The crew exploring one of the sandstone passages just off the trail.',
);

export const zionWaltersWigglesPhoto = photo(
  'walters-wiggles',
  waltersWigglesImage,
  'Looking down at the tight switchbacks of Walter’s Wiggles from the top of the climb',
  'Looking back down at Walter’s Wiggles after reaching the top of the switchbacks.',
);

export const zionScoutLookoutViewPhoto = photo(
  'scout-lookout-view',
  scoutLookoutViewImage,
  'The sweeping sandstone cliffs and canyon seen from Scout Lookout in Zion National Park',
  'The canyon and sandstone cliffs spreading out beneath Scout Lookout.',
);

export const zionScoutLookoutCrewPhoto = photo(
  'scout-lookout-crew',
  scoutLookoutCrewImage,
  'The Reckon crew celebrating together after reaching Scout Lookout in Zion National Park',
  'The crew celebrating together at Scout Lookout.',
);

export const zionWellEarnedDescentPhoto = photo(
  'well-earned-descent',
  wellEarnedDescentImage,
  'A hiker descending the sunlit trail between towering sandstone walls in Zion National Park',
  'Following the sunlit trail back down through Zion after reaching Scout Lookout.',
);

export const zionTrailEndsRiverPhoto = photo(
  'trail-ends-river',
  trailEndsRiverImage,
  'The Reckon crew standing beside the Virgin River beneath the canyon walls in Zion National Park',
  'The crew together beside the Virgin River near the end of the trail.',
);

export const zionTrailEndsCrewPhoto = photo(
  'trail-ends-crew',
  trailEndsCrewImage,
  'The Reckon crew gathered beneath the towering canyon walls where the trail ends in Zion National Park',
  'The crew together beneath the canyon walls where the trail ends.',
);

export const zionTrailEndsRestPhoto = photo(
  'trail-ends-rest',
  trailEndsRestImage,
  'The Reckon crew resting together on sandstone beneath the Zion canyon walls',
  'A final pause together beneath the canyon walls.',
);

export const zionChasingSunsetPhoto = photo(
  'chasing-sunset',
  chasingSunsetImage,
  'Zion sandstone cliffs rising above the Watchman Trail on the way to the overlook',
  'Keeping a brisk pace beneath the sandstone cliffs to reach the Watchman overlook before sunset.',
);

export const zionWatchmanOverlookPhoto = photo(
  'watchman-overlook',
  watchmanOverlookImage,
  'Five Reckon Crew members at the Watchman Trail overlook with Zion peaks behind them',
  'The crew taking in the Zion panorama from the Watchman Trail overlook.',
);

export const zionWatchmanSunsetPhoto = photo(
  'watchman-sunset',
  watchmanSunsetImage,
  'The sun setting behind layered clouds and Zion’s silhouetted ridges from the Watchman Trail overlook',
  'The sun beginning to set as we reached the Watchman Trail overlook.',
);

export const zionWatchmanTrailheadFinishPhoto = photo(
  'watchman-trailhead-finish',
  watchmanTrailheadFinishImage,
  'The Reckon crew gathered at the Watchman Trail trailhead after finishing the hike',
  'The crew back at the Watchman Trail trailhead after finishing the hike.',
);

export const zionWalkBackToVanPhoto = photo(
  'walk-back-to-van',
  walkBackToVanImage,
  'Reckon Crew members walking back to their van beneath a colorful Zion sunset',
  'Walking back to the van as our day in Zion came to an end.',
);

export const zionFinalSelfieWithSamanthaPhoto = photo(
  'final-selfie-with-samantha',
  finalSelfieWithSamanthaImage,
  'The Reckon crew taking a final selfie with Samantha beneath the Zion canyon walls',
  'One last photo with Samantha after an unforgettable day exploring Zion.',
);

const zionHikeGallery = [
  zionPlaneViewPhoto,
  zionNightSkyPhoto,
  zionSunriseCliffsPhoto,
  zionScoutsLookoutStartPhoto,
  zionGeologyBriefingPhoto,
  zionSwitchbackGroupPhoto,
  zionRockPassagePhoto,
  zionSlotCanyonCrewPhoto,
  zionWaltersWigglesPhoto,
  zionScoutLookoutViewPhoto,
  zionScoutLookoutCrewPhoto,
  zionWellEarnedDescentPhoto,
  zionTrailEndsRiverPhoto,
  zionTrailEndsCrewPhoto,
  zionTrailEndsRestPhoto,
  zionChasingSunsetPhoto,
  zionWatchmanOverlookPhoto,
  zionWatchmanSunsetPhoto,
  zionWatchmanTrailheadFinishPhoto,
  zionWalkBackToVanPhoto,
  zionFinalSelfieWithSamanthaPhoto,
];

export default zionHikeGallery;
